import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FlexRow, FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { Telegram, Vk, Tiktok } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import cls from "./styles.module.scss";

export const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isMainOrPetPage =
    location.pathname === "/" || /^\/pets\/[a-f0-9-]+$/.test(location.pathname);

  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = width <= 760;

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={isMainOrPetPage && isMobile ? cls.wrapperPadding : cls.wrapper}
    >
      <div className={cls.container}>
        <FlexRow
          gap={48}
          justifyContent="space-between"
          className={cls.footerBlock}
        >
          <FlexRow gap={16} className={cls.icons}>
            <a
              href="https://t.me/fireflies_space"
              target="_blank"
              rel="noreferrer"
            >
              <Telegram />
            </a>
            <a
              href="https://vk.com/fireflies_space"
              target="_blank"
              rel="noreferrer"
            >
              <Vk />
            </a>
            <Tiktok />
          </FlexRow>
          <FlexRow gap={48}>
            <a href="/about-us">
              <Typography
                size="2xl"
                color="#fff"
                lineHeight="32px"
                weight="semibold"
                className={cls.nav}
              >
                {t("common.aboutUs")}
              </Typography>
            </a>
            <a href="/blog">
              <Typography
                size="2xl"
                color="#fff"
                lineHeight="32px"
                weight="semibold"
                className={cls.nav}
              >
                {t("common.blog")}
              </Typography>
            </a>
            <a href="/faq">
              <Typography
                size="2xl"
                color="#fff"
                lineHeight="32px"
                weight="semibold"
                className={cls.nav}
              >
                FAQ
              </Typography>
            </a>
          </FlexRow>
          <FlexColumn gap={4} alignItems="flex-end" className={cls.footerLinks}>
            <a href="/privacy-policy">
              <Typography size="xs" color="#fff" lineHeight="20px">
                {t("common.policy")}
              </Typography>
            </a>
            <a href="/personal-data-consent">
              <Typography size="xs" color="#fff" lineHeight="20px">
                {t("common.agreement")}
              </Typography>
            </a>
            <a href="/user-agreement">
              <Typography size="xs" color="#fff" lineHeight="20px">
                {t("common.userAgreement")}
              </Typography>
            </a>

            <Typography size="xs" color="#ffffff73" lineHeight="20px">
              © fireflies 2024
            </Typography>
          </FlexColumn>
        </FlexRow>
      </div>
    </div>
  );
};
